export default __webpack_public_path__ + "static/score-0a45428b7962530c8d21928074e28b6e.png";